module.exports = __webpack_public_path__ + "img/GebaeudeinformatikerEFZ-IS-0244.76c013af.jpg";